import { type AuditWaterFixtureFormEntry } from '#packages/data-collection/models/audit-water-fixture-form';

import { FixtureTypeLabel } from '#apps/client-web/features/audit-form-water-fixture/constants';

import { type ExcelTableMapping } from '../types/excel-mapping';

/**
 * Maps Water Fixture form entries to the "2. WF" Excel sheet.
 *
 * Each entry occupies one row.
 * Columns F (Unit) and G (Usage Estimate) are formula cells in the template — skipped.
 */
export const waterFixtureTableMapping: ExcelTableMapping<AuditWaterFixtureFormEntry> = {
  label: 'Water Fixture',
  startRangeName: 'water_fixture_data_start',

  columns: [
    /* A – Section */
    {
      column: 'A',
      getValue: (e) => e.section,
    },
    /* B – Room */
    {
      column: 'B',
      getValue: (e) => e.room,
    },
    /* C – Fixture type */
    {
      column: 'C',
      getValue: (e) => (e.fixtureType ? FixtureTypeLabel[e.fixtureType] : undefined),
    },
    /* D – Qty (#) */
    {
      column: 'D',
      getValue: (e) => e.quantity,
    },
    /* E – Usage rate */
    {
      column: 'E',
      getValue: (e) => e.usageRate,
    },
    /* F – Unit (formula — skip) */
    /* G – Usage Estimate (formula — skip) */
    /* H – Comments */
    {
      column: 'H',
      getValue: (e) => e.comments,
    },
    /* I – DCA Photo IDs */
    {
      column: 'I',
      getValue: (e) => e.attachments?.map((a) => a.name).join(', '),
    },
  ],
};
